import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../common/Icons';
import CreateSmieAffiliationModal from './CreateSmieAffiliationModal';
import './AffiliationBadge.css';

export const AFFILIATION_SELECT_ADD_NEW = '__add_smie_affiliation__';

const ADD_NEW_LABEL = '＋ Nouvel organisme SMIE…';

export default function AffiliationSelect({
  id = 'co-affiliation',
  name = 'affiliation_id',
  value,
  onChange,
  affiliations = [],
  defaultAffiliation = null,
  className = 'co-aff-select',
  required = true,
  disabled = false,
  loading = false,
  loadError = '',
  canAddNew = true,
  onReloadAffiliations
}) {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const selectedId =
    value != null && value !== ''
      ? String(value)
      : defaultAffiliation?.id != null
        ? String(defaultAffiliation.id)
        : '';

  const selected = affiliations.find((a) => String(a.id) === selectedId);
  const hasAffiliations = affiliations.length > 0;
  const selectDisabled = disabled || loading;

  const handleSelectChange = (event) => {
    if (event.target.value === AFFILIATION_SELECT_ADD_NEW) {
      setShowCreateModal(true);
      return;
    }
    onChange?.(event);
  };

  const handleAffiliationCreated = async (createdOption) => {
    if (typeof onReloadAffiliations === 'function') {
      await onReloadAffiliations();
    }
    if (onChange && createdOption?.id != null) {
      onChange({
        target: {
          name,
          value: String(createdOption.id)
        }
      });
    }
  };

  const modalNode =
    canAddNew && typeof document !== 'undefined'
      ? createPortal(
          <CreateSmieAffiliationModal
            show={showCreateModal}
            onHide={() => setShowCreateModal(false)}
            onCreated={handleAffiliationCreated}
          />,
          document.body
        )
      : null;

  const selectValue = hasAffiliations ? selectedId : '';

  return (
    <div className="co-aff-field">
      <div className="co-aff-select-wrap">
        <select
          id={id}
          name={name}
          className={`${className} co-aff-select--main`}
          value={selectValue}
          onChange={handleSelectChange}
          required={required}
          disabled={selectDisabled}
          aria-describedby={`${id}-hint`}
        >
          {loading ? (
            <option value="">Chargement des affiliations…</option>
          ) : (
            <>
              {hasAffiliations && !selectedId ? (
                <option value="" disabled>
                  Choisir un organisme…
                </option>
              ) : null}
              {!hasAffiliations && !canAddNew ? (
                <option value="">Aucune affiliation disponible</option>
              ) : null}
              {affiliations.map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.shortLabel}
                </option>
              ))}
              {canAddNew ? (
                <option value={AFFILIATION_SELECT_ADD_NEW} className="co-aff-select__add-new">
                  {ADD_NEW_LABEL}
                </option>
              ) : null}
            </>
          )}
        </select>
        {loading ? (
          <span className="co-aff-select-spinner" aria-hidden>
            <span className="spinner-border spinner-border-sm text-primary" />
          </span>
        ) : null}
      </div>

      {loadError ? (
        <p className="co-aff-field-error" role="alert">
          <Icon name="exclamationTriangle" size={14} />
          {loadError}
        </p>
      ) : null}

      <p id={`${id}-hint`} className="co-aff-select-hint">
        {selected
          ? `Rattachement : ${selected.shortLabel}`
          : 'Dernière ligne du menu : créer un nouvel organisme SMIE.'}
      </p>

      {modalNode}
    </div>
  );
}
